import Yup from 'utils/extended-yup'
import ProductAttributeService from 'domains/product-attribute/services'


/**
 * Generate dynamic schema
 * @param {array} attributes - Product Attribute
 */
const dynamicSchema = ({ attributes, productSizes }) => {
  let variantSchema      = {}
  const attributesSchema = ProductAttributeService.buildFormikDatatypeValidationSchmea(attributes)

  const attributeWithQuantitySchema = {
    quantity: Yup.number().positive('Should be positive number').required('Required'),
    ...attributesSchema
  }

  // only add size validation if product size is present
  if (productSizes.length > 0) {
    variantSchema = Yup.array()
      .of(
        Yup.object().shape({
          size: Yup.string().required('Required'),
          ...attributeWithQuantitySchema
        })
      ).uniqueProperty('size', 'Each variant should have unique size')
  }
  else {
    variantSchema = Yup.array()
      .of(
        Yup.object().shape({
          ...attributeWithQuantitySchema
        })
      )
  }

  const schema = Yup.object().shape({
    variants: variantSchema.required('Required')
  })
  return schema
}

export {
  dynamicSchema
}
